module.exports = __webpack_public_path__ + "static/photo7-94f42b3d5b29861c1e939fd989f4967e.jpg";